__turbopack_context__.v({
  "helper": "input-module__wueO8G__helper",
  "input": "input-module__wueO8G__input",
  "label": "input-module__wueO8G__label",
  "sizeLg": "input-module__wueO8G__sizeLg",
  "sizeMd": "input-module__wueO8G__sizeMd",
  "sizeSm": "input-module__wueO8G__sizeSm",
});
